import axiosInstance from "../axios";
import customersSampleData from "./customers";

const USE_STATIC_DATA = false; // <-- Set to true to disable API and use local file

export const customersReport = () => {
  if (USE_STATIC_DATA) return customersSampleData;

  return axiosInstance.get("/reports/customers");
};

export const getProspects = async () => {
  return axiosInstance.get("/reports/prospects");
};

export const getOrgSummary = (id) => {
  return axiosInstance.get(`/organizations/${id}/summary`);
};

export const updateOrganization = async (id, payload) => {
  return axiosInstance.put(`/organizations/${id}`, payload);
};

export const archiveOrganization = (id) => {
  return axiosInstance.post(`/organizations/${id}/archive`);
};

export const getProjectActivities = (projectId) => {
  return axiosInstance.get(`/projects/${projectId}/activities`);
};

export const getProspectEngagementDashboard = () => {
  return axiosInstance.get("/prospect_engagement/dashboard");
};

export const createBroadcast = ({
  templateId,
  orgIds,
  schedule_time = null,
}) => {
  const payload = {
    template_id: templateId,
    org_ids: orgIds,
  };

  if (schedule_time) {
    payload.schedule_time = schedule_time;
  }

  return axiosInstance.post("/prospect_engagement/broadcast", payload);
};

export const getAllBroadcasts = () => {
  return axiosInstance.get("/prospect_engagement/broadcast_list");
};

export const sentBroadcastNotifications = (broadcastId) => {
  return axiosInstance.post("/prospect_engagement/send_notifications", {
    broadcast_id: broadcastId,
  });
};

export const importLeads = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return axiosInstance.post("/prospect_engagement/import_leads", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};
